declare var dataLayer: any;

export default {
  event(
    category: string,
    action: string = '(not set)',
    label: string = '(not set)',
    value: string = '(not set)',
  ) {
    dataLayer.push({
      event: 'general_event',
      general_event_category: category,
      general_event_action: action,
      general_event_label: label,
      general_event_value: value,
    });
  },

  fbEvent(category: string, content: string) {
    dataLayer.push({
      event: 'fb_lead',
      content_category: category,
      content_name: content,
    });
  },

  timing(naming: string, value: string|number) {
    dataLayer.push({
      event: 'timing',
      timing_name: naming,
      timing_value: value,
    });
  },
};
